// extracted by mini-css-extract-plugin
export default {"rightContent":"changePassword_rightContent__GKxgt","passwordInput":"changePassword_passwordInput__Bn5FK"};